import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=31a6d540&scoped=true"
import script from "./MarkdownView.vue?vue&type=script&lang=js"
export * from "./MarkdownView.vue?vue&type=script&lang=js"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=31a6d540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6d540",
  null
  
)

export default component.exports